import { OrganisationPermission } from "../organisation/OrganisationModelV2"

export class ACLModel {
    permissions?: OrganisationPermission
    can_receive_payment: boolean
    can_receive_reward_payment: boolean

    can_niaga: boolean

    can_manage_economics: boolean
    can_invoice: boolean
    can_prepay_contracts: boolean

    can_inspect_photos: boolean

    can_manage_crm: boolean

    can_manage_identity_access: boolean
    can_impersonate_users: boolean
    can_manage_bi: boolean

    constructor(data: any) {
        this.permissions = OrganisationPermission.build(data.organisation_permissions)
        this.can_receive_payment = data.can_receive_payment
        this.can_receive_reward_payment = data.can_receive_reward_payment
        this.can_niaga = data.can_niaga ?? data.is_granted_niaga
        this.can_manage_economics = data.can_manage_economics
        this.can_invoice = data.can_invoice
        this.can_prepay_contracts = data.can_prepay_contracts
        this.can_inspect_photos = data.can_inspect_photos
        this.can_manage_crm = data.can_manage_crm
        this.can_manage_identity_access = data.can_manage_identity_access
        this.can_impersonate_users = data.can_impersonate_users
        this.can_manage_bi = data.can_manage_bi
    }

    static build(d: any): ACLModel | undefined {
        if (!d) {
            return undefined
        }
        return new ACLModel(d)
    }

}